import React, { useEffect } from "react";

const keyname = {
  rcpts: "Taken Over [trains]",
  dspts: "Handed Over [trains]",
  diff: "Difference",
  yday: "DWB-Y-Day",
  today: "DWB-T-Day",
  WTR: "WTR",

  km_dsl_total: "Kms DSL",
  ekm_dsl: "Usage DSL",
  km_elec_total: "Kms AC",
  ekm_elec: "Usage AC",
  le_prct_dsl: "L/Engine %",
};

const TargetKeyname = {
  rcpts: "taken_over_target",
  dspts: "handed_over_target",
  today: "DWB_T_DAY_target",
  WTR: "WTR_target",
  ekm_dsl: "USAGE_DSL_target",
  ekm_elec: "USAGE_AC_target",
};

const filterKey = [
  "rcpts",
  "dspts",
  "diff",
  "yday",
  "today",
  "WTR",
  "km_elec_total",
  "ekm_dsl",
  "ekm_elec",
  "le_prct_dsl",
];

const CumulativeOperatingData = ({
  isDisabled,
  role,
  dataSet,
  targets,
  setTargets,
}) => {
  // ================= Merge API Data =================
  const lastYearData = {
    ...(dataSet?.wcrpt057?.last_yr_date_data?.[0] || {}),
    ...(dataSet?.wc017?.last_yr_date_data?.[0] || {}),
  };

  const currentYearData = {
    ...(dataSet?.wcrpt057?.current_date_data?.[0] || {}),
    ...(dataSet?.wc017?.current_date_data?.[0] || {}),
  };

  // ================= Initialize Targets =================
  useEffect(() => {
    if (!dataSet) return;

    const apiData = dataSet?.wcrpt057?.current_date_data?.[0] || {};
    const wc017Data = dataSet?.wc017?.current_date_data?.[0] || {};

    setTargets({
      taken_over_target: apiData?.taken_over_target ?? "",
      handed_over_target: apiData?.handed_over_target ?? "",
      // DWB_T_DAY_target: apiData?.DWB_T_DAY_target ?? "",
      WTR_target: apiData?.WTR_target ?? "",

      USAGE_DSL_target: wc017Data?.USAGE_DSL_target ?? "",
      USAGE_AC_target: wc017Data?.USAGE_AC_target ?? "",
      wcrpt057id: apiData?.id ?? null,
      wc017id: wc017Data?.id ?? null,
    });
  }, [dataSet, setTargets]);

  // ================= Filter Required Keys =================
  const filteredLastYear = Object.fromEntries(
    filterKey.map((key) => [key, lastYearData[key]]),
  );

  const filteredCurrentYear = Object.fromEntries(
    filterKey.map((key) => [key, currentYearData[key]]),
  );

  // ================= Editable Condition =================
  const isEditable = role === "editor" && isDisabled;

  // ================= Handle Input Change =================
  const handleTargetChange = (key, value) => {
    const targetKey = TargetKeyname[key];
    if (!targetKey) return;

    setTargets((prev) => ({
      ...prev,
      [targetKey]: Number(value), // keep string for smooth typing
    }));
  };

  return (
    <div className="table-responsive m-0 p-0">
      <table className="border border-1 border-dark text-center">
        <thead>
          <tr>
            <th className="border border-dark p-0">Head</th>
            <th className="border border-dark p-0" style={{ width: "80px" }}>
              Target
            </th>
            <th className="border border-dark p-0">Current / Year</th>
            <th className="border border-dark p-0">Last / Year</th>
            <th className="border border-dark p-0">Progressive</th>
          </tr>
        </thead>

        <tbody>
          {filterKey.map((key, index) => {
            const targetKey = TargetKeyname[key];

            return (
              <tr key={index}>
                {/* Head */}
                <td className="border border-dark p-0">
                  {keyname[key] || key}
                </td>

                {/* Target */}
                <td className="border border-dark p-0">
                  {key !== "yday" &&
                  key !== "diff" &&
                  key !== "today" &&
                  isEditable &&
                  targetKey ? (
                    <input
                      type="number"
                      min="0"
                      step="1"
                      style={{
                        width: "100%",
                        maxWidth: "80px",
                        height: "18px",
                        border: "none",
                        textAlign: "center",
                      }}
                      value={targets?.[targetKey] ?? ""}
                      onChange={(e) => handleTargetChange(key, e.target.value)}
                    />
                  ) : key === "yday" ? (
                    dataSet?.wcrpt057?.current_date_data?.[0]?.yDayTrgt || "-"
                  ) : key === "today" ? (
                    dataSet?.wcrpt057?.current_date_data?.[0]?.trgt || "-"
                  ) : (
                    (targets?.[targetKey] ?? "-")
                  )}
                </td>

                {/* Current Year */}
                <td className="border border-dark p-0">
                  {filteredCurrentYear[key] != null
                    ? Number(filteredCurrentYear[key]).toFixed(2)
                    : "-"}
                </td>

                {/* Last Year */}
                <td className="border border-dark p-0">
                  {filteredLastYear[key] != null
                    ? Number(filteredLastYear[key]).toFixed(2)
                    : "-"}
                </td>

                {/* Progressive */}
                <td className="border border-dark p-0">-</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CumulativeOperatingData;
